// enums.js
export const enumStatus = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const enumColor = {
  RED: "red",
  GREEN: "green",
  BLUE: "blue",
};

export const searchTypeEnum = {
  CUSTOMER: "CUSTOMER",
  ORDER: "ORDER",
  TRACKING_NO: "TRACKING_NO",
};

export const enumWorkingSteps = {
  pending: 1,
  assignClothToTailor: 2,
  receiveReadyClothFromTailor: 3,
  deliverClothToCustomer: 4,
};
